export class ChargePointNameModel {
    chargePointId: number;
    name: string;
    display : string;
    value : number;
}
